import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconTextFormatBold12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconTextFormatBold12"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                d="M9.659 3.714C9.659 2.03 8.326 1 5.876 1H2v10h3.938C8.651 11 10 9.986 10 8.071c0-1.085-.713-2.057-2.264-2.2C8.992 5.7 9.66 4.757 9.66 3.714m-5.21-.671h1.194c1.101 0 1.489.443 1.489.971 0 .586-.388.972-1.225.972H4.45zm3.04 4.871c0 .686-.559 1.057-1.582 1.057H4.45v-2.1h1.44c1.101 0 1.597.329 1.597 1.043"
            />
        </svg>
    );
}
export default memo(IconTextFormatBold12);
